import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-path-left"} maskId="square-filled-radius-0-stroke-1-IconArrowPathLeft"><path d="M11 3.68652V8.00014H22V16.0001H11V20.3138L0.966309 12.0001L11 3.68652Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowPathLeft;
